import React from "react";
import PropTypes from 'prop-types';
import BaseInfo from "./BaseInfo";
import ReqparamTable from './ReqparamTable';
import Table from './Table';
import StructExample from './StructExample';
import AnchorControl from "./AnchorControl";
import ErrCode from "./ErrCode";
import ApiTool from "./ApiTool";
import styles from './apiList.less';

function ApiList(props) {
    const { Id, name, baseinfo, headerData, respData, 
        bodyExample, bodyExampleXml, bodyExampleSoap1, bodyExampleSoap2,
        respExample, respExampleXml, respExampleSoap1, respExampleSoap2,
        errorCodeData
    } = props.data;
    // const bodyExample = props.data.bodyExample;
    const body = {
        example: bodyExample,
        exampleXml: bodyExampleXml,
        exampleSoap1: bodyExampleSoap1,
        exampleSoap2: bodyExampleSoap2
    }
    const resp = {
        example: respExample,
        exampleXml: respExampleXml,
        exampleSoap1: respExampleSoap1,
        exampleSoap2: respExampleSoap2
    }
    // const respExample = props.data.respExample;
    const tableText = props.data.bodyData ? '请求体参数' : 'Query参数';
    // console.log(12344)

    return (
            <div id='api' className={styles.apiContentPanel}>
                    <div id='download' className={styles.downloadContent}>
                        <BaseInfo baseinfo={baseinfo} name={name.zh_CN}/>
                        <ReqparamTable headerData={headerData}/>
                        <Table data={props.data.queryData || props.data.bodyData} text={tableText}/>
                        <Table data={respData} text="返回参数" />
                        <StructExample respExampleData={body} text="请求结构示例" />
                        <StructExample respExampleData={resp} text="返回结构示例" />
                        {/* <StructExample respExampleData={bodyExample} text="请求结构示例" /> */}
                        {/* <StructExample respExampleData={respExample} text="返回结构示例" /> */}
                        <ErrCode errorCodeData={errorCodeData}></ErrCode>
                    </div>
                    <ApiTool />
                    <AnchorControl tableText={tableText} id={Id}/>
                    {/* <button onClick={() => { props.model.invoke('click','1'); console.log(2) }}>点击</button>
                    <button onClick={() => { props.model.invoke('click','2'); console.log(2) }}>点击</button> */}
            </div>
    )
}

ApiList.propTypes = {
    data: PropTypes.object
}

export default ApiList;